
import AdminTrans from "../components/superadmin/AdminUserTransaction";

export default function SuperUserTransaction() {
  return (
    <div>
      <AdminTrans />
    </div>
  );
}
